<template>

  <div class="about__gallery">
<!--    <img-->
<!--        src="../images/bg/shape-top.svg"-->
<!--        alt=""-->
<!--        class="about__gallery-shape about__gallery-shape-top"-->
<!--    />-->

    <div class="about__arrow arrow-left"></div>
    <div class="about__arrow arrow-right"></div>
    <div class="swiper-container about-swiper">
      <div class="swiper-wrapper">
        <img v-for="slide in slides" :src="getSlideImg(slide)" class="swiper-slide" alt="">
<!--        <div class="swiper-slide" v-for="slide in slides" :key="slide">-->
<!--          <div class="swiper-lazy" :data-background="getSlideImg(slide)">-->
<!--            <div class="swiper-lazy-preloader"></div>-->
<!--          </div>-->
        </div>
      </div>
    </div>

<!--    <img-->
<!--        src="../images/bg/shape-bottom.svg"-->
<!--        alt=""-->
<!--        class="about__gallery-shape about__gallery-shape-bottom"-->
<!--    />-->
  </div>

</template>

<script>
import Swiper from "swiper";
import Mixin from "../common/mixin";

export default {
  name: "block-swiper",
  mixins: [Mixin],
  data() {
    return {
      swiper: null,
      slides: 4,
    };
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      if (this.swiper) return;
      this.swiper = new Swiper(`.about-swiper`, {
        autoplay: {
          delay: 3000,
        },
        loop: true,
        simulateTouch: true,
        slidesPerView: 3,
        // freeMode: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          // when window width is >= 320px
          560: {
            slidesPerView: 1,
          },
          800: {
            slidesPerView: 2,
            spaceBetween: 0
          },
        },
        navigation: {
          nextEl: `.arrow-right`,
          prevEl: `.arrow-left`,
        },
      });
    },
    getSlideImg(img) {
      return require(`../images/slides/${img}.jpg`);
    },
  },
}
</script>

<style src="./block-swiper.scss" lang="scss" scoped>

</style>